<p >
  main works!
</p>
<p>
  {{'Training_Registry_office' | translate}}
</p>